module.exports = __webpack_public_path__ + "img/NHaasGroteskTXPro-55Rg.a4e7899.svg";